import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { LoginControllerService } from './app-services/apiLoginAppController';
import { AppState } from '~core/states/app/app.state';


@Injectable({
  providedIn: 'root'
})
export class SAMLDataService {
  constructor(
    private appState: AppState,
    private http: HttpClient,
    private loginSvc: LoginControllerService,
    private toastr: ToastrService
  ) {}

  getSettings(): Observable<any> {
    return this.http.get<any>(`saml/idpgetsettings`);
  }

  samlLogin(samlResponse: string): Observable<any> {
    const params = {
      samlResponse
    };
    return this.http.post<string>(`saml/samllogin`, params);
  }

  ssoLogin(connectionStringName: string, facilityId: number, samlToken: string): Observable<any> {
    console.debug('Login call started...');
    return this.loginSvc.ssoLogin(connectionStringName, facilityId, samlToken)
      .pipe(
        catchError(error => {
          console.error(`Login Error: ${error?.message}`);
          this.toastr.error('Authorization Failed');
          return of(false);
        })
      );
  }
}
